namespace TabAurous.StockHelper {

    export function GetStockID(SKU: string, TransactionId: number) {

        let Rate = 0;
        let ServiceEndpoint = "/services/" + TabAurous.Common.GetItemRateService.baseUrl + "/GetPurchaseRate"

        $.ajax({
            type: "post",
            dataType: "json",
            async: false,
            url: ServiceEndpoint,
            data: {
                'SKU': SKU,
                'TransactionId': TransactionId
            },
            success: function (response) {

                if (response instanceof Object) {
                    var json = response;
                }
                else {
                    var json = $.parseJSON(response);
                }

                var output = json['result'];
                Rate = output;


            }.bind(this),
            error: function (jqxhr, textStatus, error) {
                var err = textStatus + ", " + error;
                alert("Error! " + err);
            }

        });

        return Rate;

    }
    export function GetStockDetails(item: Stock.StockItemRow, isReturn: boolean = false, vouchertypeid: number = 0): Stock.StockItemRow {

        let stockdetails: Stock.StockItemRow;
        Stock.StockItemService.GetProductDetails({
            ProductId: item.ProductId,
            Line_No: item.Line_No,
            AttributeId: item.AttributeId,
            SKU: item.SKU,
            LotNo: item.LotNo,
            TransId: item.TransId,
            TransItemId: item.TransItemId,
            RefVoucherTypeId: isReturn ? vouchertypeid : 0
        },
            response => {
                stockdetails = response.Entity;
            }, { async: false }

        );
        return stockdetails;
    }
}

